import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'; 
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import nbxTheme from '../themes/nbxTheme';
import { AuthContext } from '../../Auth';
import { ReactComponent as VisaMasterImg } from '../../images/visa_master.svg';
import { ReactComponent as PaypalImg } from '../../images/paypal.svg';
import { ReactComponent as AmericanImg } from '../../images/visa_master_american.svg';
import { ReactComponent as OxxoImg } from '../../images/oxxo.svg';
import { ReactComponent as SpeiImg } from '../../images/spei.svg';
import { ReactComponent as NbxImg } from '../../images/neubox.svg';
import GreenSwitch from '../GreenSwitch';
import { useSelector, useDispatch } from 'react-redux';
import { setDiscountNbps, setPaymentMethod } from '../../slices/profileSlice';
import { useTranslation } from 'react-i18next';

export default function AccordionUsage() {
  const { userAuth } = useContext(AuthContext);
  const [expanded, setExpanded] = React.useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const [isSwitchChecked, setIsSwitchChecked] = useState(false);
  const profile = useSelector(state => state.profile);
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(true);
  const { t } = useTranslation();
  const ResumenData = useSelector(state => state.global.ResumenData);
  const countActualTrue = ResumenData.filter((item) => item.actual === false).length;
  const msg = useSelector(state => state.global.hayNbps);

  useEffect(() => {
    if(userAuth) {
      //válida si tiene productos para habilitar o deshabilitar las opciones de pago
      if(countActualTrue) {
        setIsDisabled(false)
        // Si se actualiza la página mostrar las opciones seleccionadas por el usuario.
        setSelectedValue(profile.paymentMethod)
        setExpanded(profile.paymentMethod);
        setIsSwitchChecked(profile.discount.nbps);
      } else {
        setIsDisabled(true)
        setSelectedValue('')
        setExpanded('');
      }
      
    } else {
      setIsDisabled(true)
      setSelectedValue('')
      setExpanded('');
    }
  }); 

  const handleChange = (panel, beforePanel) => (event, isExpanded) => {
    if(userAuth && countActualTrue) {
      setExpanded(panel);
      setSelectedValue(panel);
      //set in redux
      if (profile.paymentMethod != panel) {
        dispatch(setPaymentMethod(panel));
      }

      if (panel === 'Nbp') {
        dispatch(setDiscountNbps(true));
      } else if (beforePanel === 'Nbp') {
        dispatch(setDiscountNbps(false));
      }
    }
  };

  const handleSwitchChange = (e) => {
    const isChecked = e.target.checked;
    if(userAuth) {
      setIsSwitchChecked(isChecked);
      dispatch(setDiscountNbps(isChecked)); //setea true para renderizar en resumen el descuento
    }
  };

  const handleRadioChange = (event) => {
    const { value } = event.target;
    if(userAuth) {
      setExpanded(value);
      setSelectedValue(value);
    }
  };

  const formatNumber = (number) => {
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <ThemeProvider theme={nbxTheme}>
      {(msg == 'nbps' || msg == false || msg == undefined ) && (
      <Box>
      <Accordion expanded={expanded === 'Evo'} onChange={handleChange('Evo', expanded)}>
        <AccordionSummary aria-controls="panel1-content" id="panel1-header">
        <Box className='list-item-title'>
            <FormControlLabel
              className='list-payment-title'
              value="Evo"
              control={<Radio checked={selectedValue === 'Evo'} onChange={handleRadioChange} disabled={isDisabled}/>}
              label={t("listPayments.evo.title")}
              labelPlacement="end"
              sx={{ marginRight: 2 }}
            />
            <VisaMasterImg />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <p className='list-payment-description'>
           {t("listPayments.evo.description")}
          </p>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'PayPal'} onChange={handleChange('PayPal', expanded)}>
        <AccordionSummary aria-controls="panel2-content" id="panel2-header">
        <Box className='list-item-title'>
            <FormControlLabel
              value="PayPal"
              className='list-payment-title'
              control={<Radio checked={selectedValue === 'PayPal'} onChange={handleRadioChange} disabled={isDisabled}/>}
              label={t("listPayments.paypal.title")}
              labelPlacement="end"
              sx={{ marginRight: 2 }}
            />
            <PaypalImg />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <p className='list-payment-description'>
            {t("listPayments.paypal.description")}
          </p>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'PayPalPlus'} onChange={handleChange('PayPalPlus', expanded)}>
        <AccordionSummary aria-controls="panel3-content" id="panel3-header">
        <Box className='list-item-title'>
            <FormControlLabel
              className='list-payment-title'
              value="PayPalPlus"
              control={<Radio checked={selectedValue === 'PayPalPlus'} onChange={handleRadioChange} disabled={isDisabled}/>}
              label={t("listPayments.paypalPlus.title")}
              labelPlacement="end"
              sx={{ marginRight: 2 }}
            />
            <AmericanImg />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <p className='list-payment-description'>
            {t("listPayments.paypalPlus.description")}
          </p>
        </AccordionDetails>
      </Accordion>
      </Box>
      )}
      <Accordion expanded={expanded === 'Oxxo'} onChange={handleChange('Oxxo', expanded)}>
        <AccordionSummary aria-controls="panel4-content" id="panel4-header">
        <Box className='list-item-title'>
            <FormControlLabel
              className='list-payment-title'
              value="Oxxo"
              control={<Radio checked={selectedValue === 'Oxxo'} onChange={handleRadioChange} disabled={isDisabled}/>}
              label={t("listPayments.oxxo.title")}
              labelPlacement="end"
              sx={{ marginRight: 2 }}
            />
            <OxxoImg />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <p className='list-payment-description'>
            {t("listPayments.oxxo.description")}
          </p>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'Spei'} onChange={handleChange('Spei', expanded)}>
        <AccordionSummary aria-controls="panel5-content" id="panel5-header">
        <Box className='list-item-title'>
            <FormControlLabel
              className='list-payment-title'
              value="Spei"
              control={<Radio checked={selectedValue === 'Spei'} onChange={handleRadioChange} disabled={isDisabled}/>}
              label={t("listPayments.spei.title")}
              labelPlacement="end"
              sx={{ marginRight: 2 }}
            />
            <SpeiImg />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <p className='list-payment-description'>
            {t("listPayments.spei.description")}
          </p>
        </AccordionDetails>
      </Accordion>

      {/* Pago con saldo a favor (total) */}
      { userAuth && profile.saf >= profile.total && profile.total > 0 &&  (msg == 'nbps' || msg == false || msg == undefined ) && (
        <Accordion expanded={expanded === "Saf"} onChange={handleChange("Saf", expanded)}>
          <AccordionSummary aria-controls="panel7-content" id="panel7-header">
            <Box className="list-item-title">
              <FormControlLabel
                className="list-payment-title"
                value="Saf"
                control={<Radio checked={selectedValue === "Saf"} onChange={handleRadioChange} disabled={isDisabled} />}
                label={<span>{t("listPayments.saf.title1")}<b> ${ formatNumber(profile.total) } </b>{t("listPayments.saf.title2")}</span>}
                labelPlacement="end"
                sx={{ marginRight: 2 }}
              />
              <NbxImg />
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <p className="list-payment-description">{t("listPayments.saf.description")}</p>
          </AccordionDetails>
        </Accordion>
      )}

      { //Muestra switch Neuboxpoints para pago PARCIAL
      (msg == 'nbps' || msg == false ) && userAuth && profile.nbps > 0 && profile.nbps < profile.amount  ? (
        <Accordion expanded={expanded === 'Nbp'}>
        <AccordionSummary aria-controls="panel6-content" id="panel6-header">
          <Box className='list-item-title'>
            <div className='flex-center'>
              <GreenSwitch
                {...label}
                checked={isSwitchChecked}
                onChange={handleSwitchChange}
              />
              <p className='list-switch-nbp'>{t("listPayments.nbp.apply")} <span>${profile.nbps}</span> {t("listPayments.nbp.text")}.</p>
            </div>
            <NbxImg />
          </Box>
        </AccordionSummary>
      </Accordion>
    ) : //Muestra opción Neuboxpoints para pago TOTAL
    (msg == 'nbps' || msg == false || msg == undefined ) && userAuth && profile.nbps > 0 && profile.nbps >= profile.amount && profile.amount != '0.00' ? (
      <Accordion expanded={expanded === 'Nbp'} onChange={handleChange('Nbp', expanded)}>
        <AccordionSummary aria-controls="panel6-content" id="panel6-header">
        <Box className='list-item-title'>
            <FormControlLabel
              className='list-payment-title'
              value="Nbp"
              control={<Radio checked={selectedValue === 'Nbp'} onChange={handleRadioChange} disabled={isDisabled}/>}
              label={t("listPayments.nbp.text")}
              labelPlacement="end"
              sx={{ marginRight: 2 }}
            />
            <NbxImg />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <p className='list-payment-description'>
            {t("listPayments.nbp.description")}
          </p>
        </AccordionDetails>
      </Accordion>
    ) : null}
    </ThemeProvider>
  );
}
